import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Scissors } from 'lucide-react';

export default function ArtikelRamadanKalenderSelberMachen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Ramadan Kalender selber machen: Schritt-für-Schritt</h1>
          <p className="text-lg text-white/80 leading-relaxed">Drei DIY-Anleitungen für individuelle Ramadan-Kalender – von einfach bis aufwendig.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Ein selbstgemachter Ramadan-Kalender macht den Fastenmonat für Kinder greifbar und spannend. 30 kleine Überraschungen bauen Vorfreude auf und vermitteln spielerisch islamische Werte. Hier findest du drei Anleitungen für verschiedene Schwierigkeitsgrade.</p>

          <div className="bg-[#D4C5A9]/20 border-2 border-[#D4C5A9] rounded-2xl p-6 mb-12">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-3">Was kommt rein?</h3>
            <div className="grid sm:grid-cols-2 gap-4 text-sm text-[#4B5563]">
              <div>
                <p className="font-medium text-[#2C332E] mb-2">Süßes & Snacks:</p>
                <ul className="space-y-1">
                  <li>• Halal-Bonbons</li>
                  <li>• Mini-Schokolade</li>
                  <li>• Datteln</li>
                  <li>• Kekse</li>
                </ul>
              </div>
              <div>
                <p className="font-medium text-[#2C332E] mb-2">Lehrreiches:</p>
                <ul className="space-y-1">
                  <li>• Tägliche Duas</li>
                  <li>• Gute-Taten-Aufgaben</li>
                  <li>• Quran-Verse</li>
                  <li>• Islamische Fakten</li>
                </ul>
              </div>
            </div>
          </div>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Scissors className="w-6 h-6 text-[#4A5D4F]" /></div>
              <div>
                <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Variante 1: Papiertüten-Kalender</h2>
                <p className="text-sm text-[#4A5D4F]">Einfach • 1 Stunde • Materialkosten: ~10€</p>
              </div>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6 mb-4">
              <p className="font-medium text-[#2C332E] mb-3">Du brauchst:</p>
              <ul className="text-sm text-[#4B5563] space-y-1 mb-4">
                <li>• 30 kleine Papiertüten</li>
                <li>• Schnur oder Band</li>
                <li>• Zahlen-Sticker oder Marker</li>
                <li>• Wäscheklammern oder Clips</li>
                <li>• Füllmaterial (Süßigkeiten, Zettel)</li>
              </ul>
              <p className="font-medium text-[#2C332E] mb-3">Anleitung:</p>
              <ol className="text-sm text-[#4B5563] space-y-2">
                <li>1. Tüten mit Zahlen 1-30 beschriften</li>
                <li>2. Mit Überraschungen füllen</li>
                <li>3. Oben zufalten</li>
                <li>4. Schnur spannen und Tüten mit Klammern befestigen</li>
              </ol>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Scissors className="w-6 h-6 text-[#4A5D4F]" /></div>
              <div>
                <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Variante 2: Boxen-Kalender</h2>
                <p className="text-sm text-[#4A5D4F]">Mittel • 2-3 Stunden • Materialkosten: ~20€</p>
              </div>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6 mb-4">
              <p className="font-medium text-[#2C332E] mb-3">Du brauchst:</p>
              <ul className="text-sm text-[#4B5563] space-y-1 mb-4">
                <li>• 30 kleine Pappboxen (z.B. Streichholzschachteln)</li>
                <li>• Goldenes/buntes Papier zum Bekleben</li>
                <li>• Kleber</li>
                <li>• Zahlen-Stempel oder Aufkleber</li>
                <li>• Großer Karton als Unterlage</li>
              </ul>
              <p className="font-medium text-[#2C332E] mb-3">Anleitung:</p>
              <ol className="text-sm text-[#4B5563] space-y-2">
                <li>1. Boxen mit Papier bekleben</li>
                <li>2. Mit Zahlen beschriften</li>
                <li>3. Füllen und schließen</li>
                <li>4. In 5x6 Raster auf großem Karton anordnen und festkleben</li>
                <li>5. Karton mit Mond/Stern-Motiven dekorieren</li>
              </ol>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Scissors className="w-6 h-6 text-[#4A5D4F]" /></div>
              <div>
                <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Variante 3: Stoff-Kalender</h2>
                <p className="text-sm text-[#4A5D4F]">Fortgeschritten • 4-5 Stunden • Materialkosten: ~30€</p>
              </div>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6 mb-4">
              <p className="font-medium text-[#2C332E] mb-3">Du brauchst:</p>
              <ul className="text-sm text-[#4B5563] space-y-1 mb-4">
                <li>• Großes Stück Filz oder Stoff (ca. 60x80cm)</li>
                <li>• 30 kleine Stofftaschen oder selbstgenähte Taschen</li>
                <li>• Stoffkleber oder Nähzeug</li>
                <li>• Zahlen aus Filz oder Stoff</li>
                <li>• Band zum Aufhängen</li>
              </ul>
              <p className="font-medium text-[#2C332E] mb-3">Anleitung:</p>
              <ol className="text-sm text-[#4B5563] space-y-2">
                <li>1. Taschen in 5x6 Raster auf dem Stoff anordnen</li>
                <li>2. Festnähen oder -kleben</li>
                <li>3. Zahlen auf die Taschen aufbringen</li>
                <li>4. Oben Schlaufe zum Aufhängen anbringen</li>
                <li>5. Mit Mond und Sternen dekorieren</li>
              </ol>
            </div>
            <div className="bg-[#4A5D4F]/10 rounded-lg p-4">
              <p className="text-sm text-[#4B5563]"><strong>Tipp:</strong> Dieser Kalender kann jedes Jahr wiederverwendet werden!</p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">30 Füllungs-Ideen</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#F5F5F0] rounded-xl p-4">
                <p className="font-medium text-[#2C332E] mb-2">Tage 1-10:</p>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>1. Dua für den Ramadan-Beginn</li>
                  <li>2. Süßigkeit + "Sei heute extra freundlich"</li>
                  <li>3. Arabischer Buchstabe lernen</li>
                  <li>4. Mini-Schokolade</li>
                  <li>5. "Ruf Oma/Opa an"</li>
                  <li>6. Sticker</li>
                  <li>7. Dua vor dem Essen</li>
                  <li>8. Dattel</li>
                  <li>9. "Räum dein Zimmer auf"</li>
                  <li>10. Kleines Spielzeug</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-4">
                <p className="font-medium text-[#2C332E] mb-2">Tage 11-20:</p>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>11. Fakt über den Ramadan</li>
                  <li>12. Halal-Gummibärchen</li>
                  <li>13. "Hilf beim Kochen"</li>
                  <li>14. Dua nach dem Essen</li>
                  <li>15. Halbzeit-Überraschung!</li>
                  <li>16. "Teile etwas mit deinen Geschwistern"</li>
                  <li>17. Mini-Rätsel</li>
                  <li>18. Bonbon</li>
                  <li>19. Quran-Vers</li>
                  <li>20. Kleines Buch/Heft</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Ein selbstgemachter Ramadan-Kalender ist mehr als nur ein Countdown – er ist ein Werkzeug, um Kindern den Glauben näherzubringen und Vorfreude zu schaffen. Die schönsten Erinnerungen entstehen beim gemeinsamen Basteln!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/ramadan-aktivitaeten-kinder" className="text-[#4A5D4F] hover:underline">→ Ramadan Aktivitäten für Kinder</Link></li>
              <li><Link to="/ratgeber/diy-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ DIY Eid Geschenke</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
